import * as Tabs from '@radix-ui/react-tabs'
import React, { useState } from 'react'

import type { CMSProgramTab } from '@/types/sanity'

import './Tabs.scss'
import { Tag } from '../Tag'
import clsx from 'clsx'
import { FlexibleProgramForm } from './Form'

type Props = {
  tabs: CMSProgramTab[]
}

export const FlexibleProgramTabs: React.FC<Props> = ({ tabs }) => {
  const [selectedTabId, setSelectedTabId] = useState(
    (tabs.find((tab) => tab.selected) || tabs[0])?._id,
  )

  const handleTabChange = (value: string) => {
    setSelectedTabId(value)
  }

  const hideTabs = tabs.length <= 1

  return (
    <Tabs.Root
      className="flexible-program-tabs"
      value={selectedTabId}
      onValueChange={handleTabChange}
    >
      <Tabs.List
        className={clsx(
          'flexible-program-tabs__list',
          hideTabs && 'flexible-program-tabs__list--hidden',
        )}
      >
        {tabs.map((tab) => (
          <div
            className={`flexible-program-tab ${
              tab._id == selectedTabId ? 'flexible-program-tab--selected' : ''
            }`}
            key={tab._id}
          >
            {tab.tag && (
              <div className="flexible-program-tab__tag">
                <Tag text={tab.tag} theme="lime" enforceTheme type="compact" />
              </div>
            )}
            <Tabs.Trigger
              key={tab._id}
              value={tab._id}
              className="flexible-program-tab__trigger"
            >
              <div className="type-eyebrow">{tab.associatedOption?.name}</div>
            </Tabs.Trigger>
          </div>
        ))}
      </Tabs.List>
      {tabs.map((tab) => (
        <Tabs.Content
          key={tab._id}
          value={tab._id}
          className="flexible-program-tab-content"
        >
          <FlexibleProgramForm tab={tab} />
        </Tabs.Content>
      ))}
    </Tabs.Root>
  )
}
